import React from "react";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import { useNavigate } from "react-router";
import { LOGIN_PAGE } from "../../routes";

const RegistrationSuccess: React.FC = () => {
  const isDesktop = useDesktopSize();
  const navigate = useNavigate();
  return (
    <div className={isDesktop ? "login-wrapper" : "login-wrapper-mobile"}>
      <div className={isDesktop ? "login-panel" : "login-panel-mobile"}>
        <h3 className={"registration-panel-title"}>Konto zostało pomyślnie założone</h3>
        <p className={"registration-panel-section-1"}>
          Dziękujemy za założenie konta, za chwilę powinieneś/aś dostać wiadomość email z linkiem aktywacyjnym. Kliknij
          w link i aktywuj konto.
        </p>
        <div className={"div-buttons"} style={{ justifyContent: "center" }}>
          <button className={"login-button"} onClick={() => navigate(LOGIN_PAGE)}>
            Zaloguj
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccess;
